import React from "react";

export function Title(props) {
    return <h5 className={props.className ? props.className : ''  + " font-poppins"}>{props.children}</h5>;
}